<template>
    <dialog-template
        headerTitle="积分抵现设置"
        :visible.sync="dialogTableVisible"
        :width="'346px'"
        :append-to-body="true">
        <div>
            <div class="group">
                <p class="title">抵现规则：</p>
                <el-input class="mt-10" v-model="form.amount" @input="limit1(form, 'amount')" placeholder="请输入整数">
                    <div slot="suffix" class="color-333">积分=1元</div>
                </el-input>
            </div>
            <div class="group mt-20">
                <p class="title">单笔订单抵扣上限：</p>
                <div class="mt-12">
                    <el-radio class="mr-20" v-model="form.limitation" :label="1">按积分</el-radio>
                    <el-radio class="mr-20" v-model="form.limitation" :label="2">按比例</el-radio>
                    <el-radio class="mr-20" v-model="form.limitation" :label="0">无上限</el-radio>
                </div>
                <el-input v-if="form.limitation == 1" v-model="form.point_ceiling" @input="limit1(form, 'point_ceiling')" class="mt-10" placeholder="最多可抵现积分">
                    <div slot="suffix" class="color-333">积分</div>
                </el-input>
                <el-input v-if="form.limitation == 2" v-model="form.percentage_ceiling" @input="limit2(form, 'percentage_ceiling')" class="mt-10" placeholder="抵扣金额相对于总应付款占比">
                    <div slot="suffix" class="color-333">%</div>
                </el-input>
            </div>
        </div>
        <div class="footer fx-h-center" slot="footer">
            <el-button
                type="primary"
                size="medium"
                :disabled="!isCanSubmit"
                @click="confirm">
                确认
            </el-button>
            <el-button type="default"
                size="medium"
                @click="cancel">取消</el-button>
        </div>
    </dialog-template>
</template>

<script lang="ts">
import Vue from 'vue'
import { createComponent, ref, reactive, computed } from '@vue/composition-api'
import $fetch from '@/api'
import { openMessage } from '@/utils/system'
import { inputLimit } from '../../../../utils'

export default createComponent({
    props: {
        activity: {}
    },
    setup(props, ctx) {
        const dialogTableVisible = ref(false)
        const form = ref<{ // https://yapi.senguo.me/project/14/interface/api/5429
            status: number,
            amount: string,
            limitation: number, // 抵扣上限类型 {"0": "无上限", "1": "按积分确定上限", "2": "按比例确定上限"}
            point_ceiling: string,
            percentage_ceiling: string
        }>({})
        const limit1 = inputLimit(/^[1-9]{1}([0-9]{0,4})?$/)
        const limit2 = inputLimit(/(^[1-9]{1}([0-9]{0,1})$)|(^[1]{1}(00)$)/)

        const isCanSubmit = computed(() => {
            const condition1 = form.value.amount && form.value.amount.toString().length > 0

            if (form.value.limitation === 1) {
                console.log(form.value.point_ceiling)
                return condition1 && form.value.point_ceiling.toString().length > 0
            } else if (form.value.limitation === 2) {
                return condition1 && form.value.percentage_ceiling.toString().length > 0
            } else {
                return condition1
            }
        })

        function open() {
            dialogTableVisible.value = true
            getPointDeductionActivity()
        }

        function getPointDeductionActivity() {
            $fetch.post({
                url: '/activity/getpointdeductionactivity',
                params: {}
            }).then(data => {
                if (JSON.stringify(data.activity) === "{}") {
                    form.value = {
                        status: 0,
                        amount: "",
                        limitation: 1, // 抵扣上限类型 {"0": "无上限", "1": "按积分确定上限", "2": "按比例确定上限"}
                        point_ceiling: "",
                        percentage_ceiling: ""
                    }
                } else {
                    form.value = data.activity
                    form.value.percentage_ceiling = (data.activity.percentage_ceiling * 100).toFixed()
                }
            }).catch(e => {
                openMessage("error", e.message || "获取积分抵现活动失败")
            })
        }

        function confirm() {
            $fetch.post({
                url: '/activity/updatepointdeduction',
                params: {
                    amount: +form.value.amount,
                    limitation: form.value.limitation, // 抵扣上限类型 {"0": "无上限", "1": "按积分确定上限", "2": "按比例确定上限"}
                    point_ceiling: +form.value.point_ceiling,
                    percentage_ceiling: +form.value.percentage_ceiling / 100
                }
            }).then(data => {
                openMessage("success", '更新设置成功')
                dialogTableVisible.value = false
                ctx.emit('update')
            }).catch(e => {
                openMessage("error", e.message || '更新设置失败')
            })
        }

        function cancel() {
            dialogTableVisible.value = false
        }

        return {
            form,
            limit1,
            limit2,
            dialogTableVisible,
            open,
            confirm,
            cancel,
            isCanSubmit
        }
    }
})
</script>

<style lang="scss" scoped>
.group {
    .title {
        font-size: 14px;
        color: #333;

    }
}
</style>